import { useState } from "react";

interface Props {
  emoji: string;
  title: string;
  count: number;
  previewUrl: string | null;
  onClick: () => void;
  dimmed?: boolean;
}

export function PhotoTile({
  emoji,
  title,
  count,
  previewUrl,
  onClick,
  dimmed = false,
}: Props) {
  const [imgFailed, setImgFailed] = useState(false);
  const hasPreview = !!previewUrl && !imgFailed;

  return (
    <button
      type="button"
      onClick={onClick}
      className="relative w-full overflow-hidden bg-sk-card active:scale-[0.97] transition"
      style={{
        aspectRatio: "16 / 9",
        borderRadius: 20,
        border: "1px solid var(--color-sk-line)",
        opacity: dimmed ? 0.55 : 1,
        filter: dimmed ? "saturate(0.8)" : "none",
        transitionProperty: "opacity, filter, transform",
        transitionDuration: "0.25s",
      }}
    >
      {hasPreview && (
        <img
          src={previewUrl as string}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
          onError={() => setImgFailed(true)}
        />
      )}
      {!hasPreview && (
        <div
          className="absolute inset-0 flex items-center justify-center"
          style={{ fontSize: 64, opacity: 0.4 }}
        >
          {emoji}
        </div>
      )}

      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to top, rgba(0,0,0,0.85), rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.3) 100%)",
        }}
      />

      <div className="absolute left-4 right-4 bottom-3.5 flex items-end justify-between">
        <div
          className="text-white"
          style={{ fontSize: 18, fontWeight: 600, letterSpacing: -0.3 }}
        >
          {emoji} {title}
        </div>
        <div
          className="text-white"
          style={{
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: 0.4,
            background: "rgba(255,255,255,0.18)",
            padding: "4px 8px",
            borderRadius: 100,
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            fontFamily: "var(--font-sk-mono)",
          }}
        >
          {count}
        </div>
      </div>
    </button>
  );
}
